import React from 'react';

/**
 * Renders the content of a card component.
 *
 * @component
 * @param {Object} props - The properties passed to the component.
 * @param {ReactNode} props.children - The content to be rendered inside the card.
 * @returns {JSX.Element} The rendered card content.
 */
function CardContent(props) {
	return <div className="prc__card--info">{props.children}</div>;
}

export default CardContent;
